import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function Showcase() {
  return <section className="relative w-full py-8 overflow-hidden bg-[#117278]" data-id="element-131">
      {/* Subtle Background Overlay */}
      <div className="absolute inset-0 z-0 opacity-20 mix-blend-overlay" data-id="element-132">
        <img src="https://cdn.magicpatterns.com/uploads/aDXiLNj2GE1K3JtnCckmmT/pexels-askar-abayev-6192011.jpg" alt="Background Texture" className="w-full h-full object-cover" data-id="element-133" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-134">
        {/* Left Column: Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="lg:col-span-7 space-y-8" data-id="element-135">
          <div className="relative" data-id="element-136">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '80px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="absolute -top-6 left-0 h-1 bg-[#992f74]" data-id="element-137" />
            <h2 className="text-3xl md:text-4xl font-montserrat font-black italic tracking-wide text-white uppercase drop-shadow-lg leading-none" data-id="element-138">
              The Sips & Nibblez
              <br data-id="element-139" />
              Experience
            </h2>
          </div>

          <div className="space-y-8 text-white/90 font-light leading-relaxed text-base md:text-lg" data-id="element-140">
            <p data-id="element-141">
              <strong className="text-white font-semibold" data-id="element-142">
                We believe every event deserves a taste of luxury.
              </strong>{' '}
              From bespoke cocktails and mocktails to gourmet bites and
              desserts, our offerings are thoughtfully curated to delight your
              guests and elevate your celebration.
            </p>
            <p data-id="element-143">
              Our live mixology sessions and interactive cocktail bar moments
              bring energy and excitement to any gathering. We bring the flavor,
              creativity, and professionalism that make every moment
              unforgettable.
            </p>

            <div className="pt-4 border-t border-white/20" data-id="element-144">
              <p className="font-montserrat text-xl md:text-2xl italic text-white leading-snug mb-8" data-id="element-145">
                Because here, pour decisions always taste better.
              </p>

              <motion.a href="/book" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-block bg-white text-black px-8 py-3 text-sm font-bold tracking-widest uppercase hover:bg-[#992f74] hover:text-white transition-colors duration-300 shadow-lg" data-id="element-146">
                Book Your Event
              </motion.a>
            </div>
          </div>
        </motion.div>

        {/* Right Column: Portrait Video */}
        <div className="lg:col-span-5 relative flex justify-center lg:justify-end" data-id="element-147">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: 'easeOut'
        }} className="relative w-full max-w-[320px] aspect-[9/16] bg-[#0a0a0a] p-3 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.7)] border border-white/10 rounded-xl overflow-hidden" data-id="element-148">
            <div className="w-full h-full relative rounded-lg overflow-hidden" data-id="element-149">
              <video src="https://cdn.magicpatterns.com/uploads/qD7qj5CyaYYhrPEdxuioqQ/IMG_5491.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-150" />
              <div className="absolute inset-0 border border-[#D4AF37]/30 rounded-lg pointer-events-none" data-id="element-151"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}